<template>
  <BaseModal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :size="'xl'"
    :is-editable="false"
    :is-archivable="false"
  >
    <template #header>
      {{ $t('views.exsbinvoices.create.title') }}
    </template>
    <template #body>
      <create :id-firm="idFirm"></create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/Create'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'InvoiceCreateModal',
  props: ['idFirm'],

  components: {
    BaseModal,
    Create
  },

  computed: {
    ...mapGetters({
      isVisible: 'exsbinvoice/createModal/isVisible',
      created: 'exsbinvoice/create/created'
    })
  },

  watch: {
    created (val) {
      if (val) {
        this.hideModal()
      }
    }
  },

  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/createModal/toggleModal'
    }),
    ...mapActions({
      reset: 'exsbinvoice/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
